// extracted by mini-css-extract-plugin
module.exports = {"clickableRow":"ReputationInsightReport_clickableRow__2rIzo"};